import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  IconButton,
  Menu,
  ListItemText,
  TextField,
  InputAdornment,
} from '@mui/material'
import FilterListIcon from '@mui/icons-material/FilterList'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { useEffect, useState } from 'react'
import styles from './nbDetails.module.scss'
import ClearIcon from '@mui/icons-material/Clear'
import strings from 'strings'


interface IAssetActivityScoringToolbarProps {
  activityFilter: string
  setActivityFilter: (value: string) => void
  onSearchChange?: (value: string) => void
  menuItems?: { label: string; key: string; action: () => void }[]
  searchValue?: string
  loading: boolean
}

const AssetActivityScoringToolbar: React.FC<IAssetActivityScoringToolbarProps> =
  ({
    activityFilter,
    setActivityFilter,
    onSearchChange,
    menuItems = [],
    searchValue,
    loading,
  }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const isMenuOpen = Boolean(anchorEl)
    const [localSearch, setLocalSearch] = useState<string>(searchValue || '')
    const t = strings.CARRIERS.DETAILS_TAB;
    useEffect(() => {
      setLocalSearch(searchValue || '')
    }, [searchValue])

    return (
      <Box className={styles.assetActivityToolbar} data-testid="asset-activity-toolbar">
        <Box className={styles.toolbarLeft} data-testid="asset-activity-toolbar-left">
          {menuItems && menuItems.length > 0 && (
            <Box className={styles.moreContainer}>
              <IconButton
                id="actionsButtonTopRow"
                data-testid="asset-activity-toolbar-actions-menu"
                onClick={(e) => {
                  if (loading) return
                  setAnchorEl(e.currentTarget)
                }}
                size="small"
                className={styles.moreButton}
              >
                <MoreVertIcon htmlColor={loading ? 'lightgrey' : 'grey'} />
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={isMenuOpen}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                data-testid="asset-activity-toolbar-menu"
              >
                {menuItems.map((item) => (
                  <MenuItem
                    key={item.key}
                    data-testid={`asset-activity-toolbar-menu-item-${item.key}`}
                    onClick={() => {
                      item.action()
                      setAnchorEl(null)
                    }}
                  >
                    <ListItemText>{item.label}</ListItemText>
                  </MenuItem>
                ))}
              </Menu>
            </Box>
          )}
          <Box className={styles.filterIconContainer}>
            <FilterListIcon htmlColor={loading ? 'lightgrey' : 'grey'} />
          </Box>
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <TextField
              placeholder={t.SEARCH_AND_FILTER}
              className={styles.textField}
              value={localSearch}
              disabled={loading}
              inputProps={{ 'data-testid': 'asset-activity-toolbar-search' }}
              onChange={(e: any) => {
                if (loading) return
                setLocalSearch(e.target.value)
                onSearchChange && onSearchChange(e.target.value)
              }}
              InputProps={{
                endAdornment: localSearch && (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setLocalSearch('')
                        onSearchChange && onSearchChange('')
                      }}
                      edge="end"
                      size="small"
                      data-testid="asset-activity-toolbar-search-clear"
                    >
                      <ClearIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FormControl size="small" disabled={loading} className={styles.activityFilter} data-testid="asset-activity-toolbar-filter-container">
              <InputLabel id="activity-select-label">{t.ASSET_STATUS}</InputLabel>
              <Select
                labelId="activity-select-label"
                id="activity-select"
                value={activityFilter}
                onChange={(e) => setActivityFilter(e.target.value)}
                label={t.ASSET_STATUS}
                inputProps={{ 'data-testid': 'asset-activity-toolbar-activity-select' }}
              >
                <MenuItem value="active" data-testid="asset-activity-filter-active">{t.ACTIVE}</MenuItem>
                <MenuItem value="inactive" data-testid="asset-activity-filter-inactive">{t.INACTIVE}</MenuItem>
                <MenuItem value="all" data-testid="asset-activity-filter-all">{t.ALL_ASSETS}</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      </Box>
    )
  }

export default AssetActivityScoringToolbar
